module.exports = __webpack_public_path__ + "media/site_templates/www.skipbinhire.company/images/our_services_3-59caeca25dd92899cd32f6f893f2fcfe.jpg";